import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { ActiveSupplierQuoteFragmentDoc } from './ActiveSupplierQuote.generated'
import * as Types from './purchasePlus_graphql'

export const AdvancedPrLineQuantityLineFragmentDoc = gql`
  fragment AdvancedPrLineQuantityLine on RequisitionLine {
    id
    uuid
    quantity
    unitPrice
    taxPercentage
    cataloguedProduct {
      id
    }
    supplier {
      id
    }
    product {
      id
    }
    availableQuotes {
      unitPrice
      taxPercentage
      ...ActiveSupplierQuote
    }
  }
  ${ActiveSupplierQuoteFragmentDoc}
` as unknown as DocumentNode<Types.AdvancedPrLineQuantityLineFragment, unknown>
